import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { SamplecoLineFilterReq } from "@project-management-system/shared-models";
import { Repository } from "typeorm";
import { buyerEntity } from "../entities/buyer-master.entity";
import { SamplePoOrderEntity } from "../entities/sample-po-order.entity";


@Injectable()
export class samplePoOrderRepository extends Repository<SamplePoOrderEntity> {
    constructor(@InjectRepository(SamplePoOrderEntity) private userRepository: Repository<SamplePoOrderEntity>
    ) {
        super(userRepository.target, userRepository.manager, userRepository.queryRunner);
    }

    async getSampleOrderDataForCoLine(): Promise<any> {
        const query = this.createQueryBuilder('spo')
            .select(`spo.buyer_style,spo.buyer_code,spo.buyer_address,spo.earliest_ex_fty,spo.delivery_date,spo.delivery_address,spo.item_description,spo.order_qty,
               spo.sales_price,spo.currency,spo.discount_item,spo.sample_item_no, bm.buyer_name,bm.sales_person,bm.discount_one,bm.item_responsible,bm.delivery_terms,bm.packaging_trims,
              bm.delivery_method, bm.payment_method, bm.payment_terms, bm.facility, bm.ware_house, bm.pch, bm.buyer_po_date, bm.buyer_po, bm.shipment_type,
              bm.agent, bm.sp_qty,bm.status`)
            .leftJoin(buyerEntity, 'bm', 'bm.buyer_code = spo.buyer_code')
            .where(`spo.status != 'SUCCESS' AND spo.status != 'INPROGRESS' AND spo.is_active = true`)

        return await query.getRawOne()
    }

    async getDistinctBuyerCode(): Promise<any[]> {
        const query = this.createQueryBuilder('spo')
            .select('DISTINCT buyer_code');

        return await query.getRawMany()
    }


    async getDistinctBuyerStyle(req: SamplecoLineFilterReq): Promise<any[]> {
        let query = this.createQueryBuilder('spo')
            .select('DISTINCT buyer_style');
        return await query.getRawMany()
    }
}